<template>
  <div class="block-wrap">
    <div class="development">
      <div class="block-title">
        <h3>发展战略</h3>
        <span>Development Strategy</span>
      </div>
      <div class="flex">
        <div class="development-nav" ref="scrollBox">
          <div>
            <div class="development-nav-item"
                :class="index === timelineActive ? 'active' : ''"
                v-for="(item, index) in list"
                :key="'development'+index"
                @click="onActive(index)">
              <span class="development-nav-item-num">{{item._index}}</span>
              <div class="development-nav-item-box">
                <p>{{item.eventTitle}}</p>
                <p>{{item._releaseTime}}</p>
              </div>
              <i class="development-nav-item-icon"></i>
            </div>
          </div>
        </div>
        <div class="development-content">
          <h3 class="hand" @click="toDetail(activeGreat)">{{activeGreat.eventTitle}}</h3>
          <div class="block-detail-icon"><i></i><i></i><i></i></div>
          <div class="development-content-desc">
            {{activeGreat.briefIntroduction}}
          </div>
          <div class="development-content-imgs">
            <img :src="activeGreat.coverImg" alt="">
            <div class="pagi" v-if="list.length > 1">
              <div class="button-prev" :class="timelineActive === 0 ? 'disable' : ''" @click="onTimelinePrev"></div>
              <div class="button-next" :class="timelineActive === list.length - 1 ? 'disable' : ''" @click="onTimelineNext"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SplitLine />
  </div>
</template>

<script>
import router from '@/router';
import greatEventTempImg from '@/assets/images/about-us-incorporation.png';

export default {
  data() {
    return {
      greatEventTempImg,
      timelineActive: 0,
    }
  },
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    activeGreat() {
      if (this.list.length) {
        return this.list[this.timelineActive];
      }
      return {}
    }
  },
  methods: {
    onActive(idx) {
      this.timelineActive = idx;
    },
    onTimelinePrev() {
      const idx = this.timelineActive;
      if (idx === 0) return;
      this.timelineActive = idx - 1;
      this.onTimelineChange();
    },
    onTimelineNext() {
      const idx = this.timelineActive;
      if (idx === this.list.length - 1) return;
      this.timelineActive = idx + 1;
      this.onTimelineChange();
    },
    onTimelineChange() {
      const idx = this.timelineActive;
      const listLenth = this.list.length;
      if (listLenth <= 4) return;
      this.$refs.scrollBox.scrollTop = `${114 * (idx - 3)}`;
    },
		toDetail(item) {
			router.push(`/aboutus/great/detail?aId=${item.id}`);
		}
  }
}
</script>

<style lang="less" scoped>
.flex {
  display: flex;
  justify-content: space-between;
}
.block-title {
  display: flex;
  align-items: flex-end;

  h3 {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #131415;
    margin-right: 20px;
  }

  span {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #131415;
    opacity: 0.2;
  }
}
.development {
  padding-top: 86px;

  .block-title {
    margin-bottom: 49px;
  }

  .development-nav {
    height: 456px;
    overflow-x: hidden;
    overflow-y: auto;
    margin-right: 100px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 2px;
    }

    &-item {
      width: 366px;
      height: 114px;
      background: #FFFFFF;
      padding: 35px 30px 30px 35px;
      display: flex;
      align-items: center;
      color: #9D9E9E;
      cursor: pointer;

      &:hover, &.active {
        background: linear-gradient(90deg, #04CF74, #06AE63);
        box-shadow: 0px 5px 20px 0px rgba(12,72,16,0.1800);
        color: #FFFFFF;

        .development-nav-item-icon {
          width: 36px;
          height: 36px;
          background-image: url(../../assets/images/about-us-arrow-hover.png);
        }
      }

      &-num {
        font-size: 50px;
        font-family: Bebas Neue;
        font-weight: 400;
        margin-right: 26px;
      }

      &-box {
        p {
          &:first-child {
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: bold;
            margin-bottom: 3px;
          }

          &:last-child {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
          }
        }
      }

      &-icon {
        width: 19px;
        height: 15px;
        margin-left: auto;
        background: url(../../assets/images/about-us-arrow.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }

  .development-content {
    flex: 1;

    h3 {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #131415;
      margin-bottom: 26px;
    }

    &-desc {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #787878;
      line-height: 28px;
      margin-bottom: 93px;
    }

    &-imgs {
      position: relative;
      
      &::after {
        content: '';
        position: absolute;
        left: 393px;
        top: 153px;
        width: 214px;
        height: 144px;
        background: url(../../assets/images/about-dev-img-bg.png) no-repeat center center;
        background-size: 100% 100%;
      }
      img {
        display: block;
        width: 472px;
        height: 250px;
      }
      .pagi {
        height: 30px;
        display: flex;
        justify-content: flex-end;

        > div {
          width: 30px;
          height: 100%;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          cursor: pointer;

          &.button-prev {
            background-image: url(../../assets/images/active-prev.png);
            margin-right: 20px;

            &.disable {
              background-image: url(../../assets/images/active-prev-disable.png);
            }
          }

          &.button-next {
            background-image: url(../../assets/images/active-next.png);
            margin-right: 20px;

            &.disable {
              background-image: url(../../assets/images/active-next-disable.png);
            }
          }
        }
      }
    }
  }
}
</style>